/**
 * inputTextareaDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import isFunction from 'lodash-es/isFunction';

export function inputTextareaDirective() {
    return {
        //language=HTML
        template: `
            <md-input-container class="md-input-has-placeholder">
                <label>{{ label }}</label>

                <textarea type="text"
                          name="{{ name || '' }}"
                          ng-model="value"
                          ng-change="_onChange()"
                          ng-disabled="disabled"
                          ng-readonly="readOnly"
                          ng-maxlength="maxlength"
                          ng-required="required"></textarea>

                <div class="hint" ng-if="hint">{{ hint }}</div>

                <div class="app-input-char-count"
                     ng-if="!hint && maxlength">
                    {{ value.length || 0 }}/{{ maxlength }}
                </div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            dispatchChange: '&?change',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@hint',
            label: '@label',
            maxlength: '@?maxlength',
            name: '@name',
            placeholder: '@placeholder',
            required: '=?required',
            value: '=value',
            readOnly: '=ngReadonly',
            mdNoFloat: '=?mdNoFloat',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            const $textarea = element.find('textarea');

            // Methods
            scope._onChange = _onChange;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            if (!angular.isDefined(scope.mdNoFloat)) {
                scope.mdNoFloat = scope.mdNoFloat === undefined && attrs.mdNoFloat !== undefined;
            }

            scope.$watch('placeholder', value => {
                $textarea[0].placeholder = value || '';
            });

            function _onChange() {
                if (isFunction(scope.dispatchChange)) {
                    scope.dispatchChange({
                        value: scope.value,
                    });
                }
            }
        },
    };
}
